var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrewdriverWrenchSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331.8,224.1c28.3,0,54.9,11,74.9,31l19.6,19.6c40-17.7,71.2-53.3,81.6-96.6c5.7-23.9,5.3-47.1,0.2-68.4 c-2.6-10.9-16.4-14.5-24.3-6.6l-68.9,68.9h-75.6V97.2l68.9-68.9c7.9-7.9,4.3-21.7-6.6-24.3c-21.3-5.1-44.5-5.5-68.4,0.2 c-55.3,13.2-98.4,60.2-107.2,116.4c-1.4,8.3-1.7,16.4-1.6,24.4l82.8,82.9C315.2,225.1,323.5,224.1,331.8,224.1z M384,278.6 c-23.2-23.2-57.6-27.6-85.4-13.9L191.1,158V96L64,0L0,63.1l96,127.1l62,0l106.7,106.6c-13.7,27.8-9.3,62.2,13.9,85.4l117,117.1 c14.6,14.5,38.2,14.5,52.7,0l52.8-52.8c14.5-14.5,14.5-38.1,0-52.7L384,278.6z M227.9,307l-59.2-59.1L19.8,396.8 c-26.4,26.4-26.4,69.1,0,95.5C33,505.4,50.2,512,67.5,512s34.5-6.6,47.7-19.8l119.1-119.1C225.5,352.3,222.6,329.4,227.9,307z  M64,472c-13.2,0-24-10.8-24-24c0-13.3,10.8-24,24-24s24,10.7,24,24S77.2,472,64,472z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrewdriverWrenchSolid);
export default __webpack_public_path__ + "static/media/screwdriver-wrench-solid.03c60a35f2595b2a51d478c7e7e26517.svg";
export { ForwardRef as ReactComponent };